import { Cookies } from 'react-cookie';

import { SetActivationSignalFormValues } from './../types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export interface SetActivationSignalStatusInterface {
  statusData: SetActivationSignalFormValues;
  id: string;
}

export const putSetActivationSignalStatus = async ({ statusData, id }: SetActivationSignalStatusInterface) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.put(
    `/set-status-to-trap-activation-signal/${id}/`,
    {
      ...statusData,
    },
    {
      headers: {
        Authorization: token,
      },
    },
  );

  return data.data as any;
};
